<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="fmh"><span class="epub-i">Contents</span></p>
<p class="cct"><span href="#/xhtml/title#tit" title="Link target outside of Sample"><span class="epub-i">Title Page</span></span></p>
<p class="cct"><span href="#/xhtml/copyrightnotice#cpynte" title="Link target outside of Sample"><span class="epub-i">Copyright Notice</span></span></p>
<p class="cct"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample"><span class="epub-i">Dedication</span></span></p>
<p class="cct-1"><a href="#/xhtml/acknowledgements#ack"><span class="epub-i">Acknowledgments</span></a></p>
<p class="cct"><a href="#/xhtml/chapter1#ch1">The Evening News Is Bad for Your Health</a></p>
<p class="cct"><a href="#/xhtml/chapter2#ch2">You Can Drown in the Fountain of Youth</a></p>
<p class="cct"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">O.J. in the Morning, G&amp;T at Night</span></p>
<p class="cct"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Beware of Animal Crackers in Your Soup</span></p>
<p class="cct"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Over Your Shoulder and onto the Green</span></p>
<p class="cct"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">If You Can’t Pet ’Em, Don’t Get ’Em</span></p>
<p class="cct"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">You Are Who You Are Until You Aren’t</span></p>
<p class="cct"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">You Are Harboring a Snake in the AT&amp;T Bushes</span></p>
<p class="cct"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Out of the Rat Race and into the Trap</span></p>
<p class="cct"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Either Use It or Lose It</span></p>
<p class="cct"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Coming to the Reunion? Thanks, but No Thanks.</span></p>
<p class="cct"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Kidnap Yourself for Thirty Minutes Every Day</span></p>
<p class="cct"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">What You Can’t Hear Can’t Hurt You</span></p>
<p class="cct"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Your Stockpiling Years Are Now Paying Dividends</span></p>
<p class="cct"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Nip Your Nuptial Before Your Nuptial Nips You</span></p>
<p class="cct"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Yes, Richard, There Is a Santa Claus</span></p>
<p class="cct"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">The World Is Your Oyster, So Shuck It</span></p>
<p class="cct"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">When You Leave What You Leave, Do You Leave It?</span></p>
<p class="cct"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">It’s All Hanging in the Balance</span></p>
<p class="cct"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">The Past Is Sometimes the Present</span></p>
<p class="cct"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">You Are the Motorman, Conductor, and Passenger</span></p>
<p class="cct"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">The Train Is Pulling Out, Step Gently On</span></p>
<p class="cct-1"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">By the Light of the Lopsided Moon</span></p>
<p class="cct"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample"><span class="epub-i">Also by A. E. Hotchner</span></span></p>
<p class="cct"><span href="#/xhtml/aboutauthor#abt" title="Link target outside of Sample"><span class="epub-i">About the Author</span></span></p>
<p class="cct"><span href="#/xhtml/copyright#cpy" title="Link target outside of Sample"><span class="epub-i">Copyright</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?9f5ed5d8